import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    :root{
        --background: #F5F5F7;
        --white: #FFFFFF;
        --red: #FF4D5E;
        --green: #03A03E;
        --blue: #256CE1;
        --grey: #8E92BC;
        --light-grey: #F5F5F7;
        --light-blue: #DCE4FF;
        --blue-light:#6933ff;
        --txt-title: #141522;
        --txt-subtitle: #54577A;
        --txt-body: #030410;
        --box-background: #F5F5F7;
        --shape:#ffffff;
    }
    *{
      margin:0;
      padding:0;
      box-sizing:border-box; 
    }

    /*font-size 16px (Desktop)*/  
    html{
        @media (max-width:1080px){
            font-size: 93.75%; /* 15px*/
        }

        @media (max-width:720px){
            font-size: 87.5%: /*14px*/
        }
    }
    /*REM ==> Medida. Retorna o tamanho do font-size da nossa página em 1rem */
    /*REM = 1rem = 16px */

    body{
        background: var(--background);
        -webkit-font-smoothing: antialiased;
        font-family: 'Plus Jakarta Sans', sans-serif;
    }

    body, input, textarea, button {
        font-weigth: 400;
    }

    h1. h2. h3, h4, h5, h6, strong {
        font-weigth: 600;
    }

    button{
        cursor: pointer;
    }

    [disabled]{
        opacity: 0.6;
        cursor: not-allowed;
    }

`;
